import { Box, Grid, Typography, Tooltip, List, ListItem, Avatar,capitalize } from "@mui/material";
import moment from "moment";
import RectangleIcon from "@mui/icons-material/Rectangle";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import queryGraphql from "../../helpers/ApiInterface";
interface ServicesTableProps {
	columnFilters: any;
	services: any;
	type: any;
	resourceStatuses: any;
}
const ServicesTable: React.FC<ServicesTableProps> = ({
	type,
	services,
	columnFilters,
	resourceStatuses
}) => {
	const [cardHoverIndex, setCardHoverIndex] = React.useState<number | null>(null);
	const navigate = useNavigate();
	



	return (
		<List sx={{ bgcolor: "#fafafa" }}>
			<ListItem sx={{ bgcolor: "#f2f2f2", borderRadius: "4px" }}>
				<Box width="100%">
					<Grid container direction="row" alignItems="center">
						<Grid item xs={2}>
							<Typography fontSize="12px">SERVICE NAME</Typography>
						</Grid>
						<Grid item xs={2}>
							<Typography fontSize="12px">APPLICATION NAME</Typography>
						</Grid>
						<Grid item xs={2}>
							<Typography fontSize="12px">CLUSTER NAME</Typography>
						</Grid>

						<Grid textAlign="start" item xs={2}>
							<Typography fontSize="12px">FRAMEWORK</Typography>
						</Grid>
						<Grid item textAlign="start" xs={2}>
							<Typography fontSize="12px">OWNER</Typography>
						</Grid>
						<Grid item textAlign="start" xs={2}>
							<Typography fontSize="12px">REQUESTED ON</Typography>
						</Grid>
					</Grid>
				</Box>
			</ListItem>
			{services.map((service: any, index: number) => (
				<ListItem
					sx={{
						border: cardHoverIndex == index ? "1px solid #000" : "1px solid #00000000",
						mt: 1,

						bgcolor: type == "active" ? "#FFFFFF" : type == "rejected" ? "#F0443810" : "#FDB02210",
						borderRadius: "8px",
						cursor: "pointer",
					}}
					onMouseEnter={() => setCardHoverIndex(index)}
					onMouseLeave={() => {
						setCardHoverIndex(null);
					}}
					onClick={() => {
						navigate(`/services/details/${service.id}`);
					}}
				>
					<Box width="100%">
						<Grid container direction="row" alignItems="center" justifyContent="space-between">
							<Grid item xs={2}>
								{columnFilters.serviceName && (
									<Box sx={{ display: "flex", alignItems: "center" }}>
										<RectangleIcon
											sx={{
												color:
													type == "active" ? "#12B76A" : type == "rejected" ? "#F04438" : "#FDB022",
												bgcolor:
													type == "active" ? "#12B76A" : type == "rejected" ? "#F04438" : "#FDB022",
												width: "4px",
												marginRight: "8px",
											}}
										/>
										<Typography fontSize="14px" fontFamily="Gilroy-Medium">
											{service.serviceName}
										</Typography>{service && service.status === 'active' ? ( 
										  <Tooltip
											sx={{ whiteSpace: "pre-line" }}
											title={
											  <Box key="applications-tooltip"> 
												Current Status
												<br />
												{resourceStatuses.filter((e:any) => e.resourceId == service.id).map((e: any, index: number) => (
												  <React.Fragment key={index}>
													{capitalize(e.currentStatus)}
													<br />
												  </React.Fragment>
												))}
												
											  </Box>
											}
										  >
											<Avatar
											  src="/assets/info.svg"
											  alt="info"
											  sx={{ height: 16, width: 16, marginLeft: "4px" }}
											/>
										  </Tooltip>
										) : null}
									</Box>
								)}
							</Grid>
							<Grid item xs={2}>
								{columnFilters.applicationName && (
									<Typography fontSize="14px" fontFamily="Gilroy-Regular">
										{service.applicationName}
									</Typography>
								)}
							</Grid>
							<Grid item xs={2}>
								{columnFilters.clusterName && (
									<Typography fontSize="14px" fontFamily="Gilroy-Regular">
										{service.clusterName}
									</Typography>
								)}
							</Grid>
							<Grid item xs={2}>
								{columnFilters.framework && (
									<Typography fontSize="14px" fontFamily="Gilroy-Regular">
										{service.framework}
									</Typography>
								)}
							</Grid>

							<Grid item xs={2}>
								{columnFilters.serviceOwner && (
									<Box sx={{ display: "flex", alignItems: "center" }}>
										<Avatar
											src={service.serviceOwnerAvatar}
											alt={service.serviceOwner}
											sx={{ marginRight: "8px", height: 30, width: 30 }}
										/>
										<Typography fontSize="14px" fontFamily="Gilroy-Regular">
											{service.serviceOwner}
										</Typography>
									</Box>
								)}
							</Grid>

							<Grid item xs={2}>
								{columnFilters.createdAt && (
									<Box display="flex" alignItems="center" justifyContent="space-between">
										<Typography fontSize="14px" fontFamily="Gilroy-Regular">
											{moment(service.createdAt).format("DD/MM/YYYY | hh:mm A")}
										</Typography>
									</Box>
								)}
							</Grid>
						</Grid>
					</Box>
				</ListItem>
			))}
		</List>
	);
};

export default ServicesTable;
